import { QUERY_KEYS } from '../../../../consts';
import { loginWithTokenService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const loginWithTokenAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER_SESSION.LOGIN,
  mutationFn: () => loginWithTokenService,
});
